const Application = { 
    development: {
        profile: "development",
        server: "//39.103.143.136/ve-server/web/",
        sso: {
            url: {
                auth: "https://www.coufran.cn/sso/auth.html"
            }
        },
        mock: {
            login: false,
            sso: false
        },
        debug: false
    },
    test: {
        profile: "test",
        server: "//test.coufran.cn/ve-server/web/",
        sso: {
            url: {
                auth: "https://www.coufran.cn/sso/auth.html"
            }
        },
        mock: {
            login: false,
            sso: false
        },
        debug: true
    },
    production: {
        profile: "production",
        server: "//www.coufran.cn/ve-server/web/",
        sso: {
            url: {
                auth: "https://www.coufran.cn/sso/auth.html"
            }
        },
        mock: {
            login: false,
            sso: false
        },
        debug: false
    }
};

export default Application[process.env.NODE_ENV];